module.exports = __webpack_public_path__ + "static/media/kaspi-logo.81d4e1b6.svg";